/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

export type ListResourceAudienceSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

/**
 * The kind of resource to describe.
 */
export const QueryParamResourceKind = {
  Mcp: "mcp",
} as const;
/**
 * The kind of resource to describe.
 */
export type QueryParamResourceKind = ClosedEnum<typeof QueryParamResourceKind>;

export type ListResourceAudienceRequest = {
  /**
   * The kind of resource to describe.
   */
  resourceKind: QueryParamResourceKind;
  /**
   * The resource to describe.
   */
  resourceId: string;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListResourceAudienceSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListResourceAudienceSecurity$outboundSchema: z.ZodMiniType<
  ListResourceAudienceSecurity$Outbound,
  ListResourceAudienceSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listResourceAudienceSecurityToJSON(
  listResourceAudienceSecurity: ListResourceAudienceSecurity,
): string {
  return JSON.stringify(
    ListResourceAudienceSecurity$outboundSchema.parse(
      listResourceAudienceSecurity,
    ),
  );
}

/** @internal */
export const QueryParamResourceKind$outboundSchema: z.ZodMiniEnum<
  typeof QueryParamResourceKind
> = z.enum(QueryParamResourceKind);

/** @internal */
export type ListResourceAudienceRequest$Outbound = {
  resource_kind: string;
  resource_id: string;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListResourceAudienceRequest$outboundSchema: z.ZodMiniType<
  ListResourceAudienceRequest$Outbound,
  ListResourceAudienceRequest
> = z.pipe(
  z.object({
    resourceKind: QueryParamResourceKind$outboundSchema,
    resourceId: z.string(),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      resourceKind: "resource_kind",
      resourceId: "resource_id",
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
    });
  }),
);

export function listResourceAudienceRequestToJSON(
  listResourceAudienceRequest: ListResourceAudienceRequest,
): string {
  return JSON.stringify(
    ListResourceAudienceRequest$outboundSchema.parse(
      listResourceAudienceRequest,
    ),
  );
}
